import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  IFeeStructure,
  IFeeStructures,
  IFeeSummary,
  IPayments,
  IStudentFees,
} from '../interfaces/fees';

@Injectable({
  providedIn: 'root',
})
export class FeeService {
  constructor(private httpClient: HttpClient) {}

  getFeeStructures(url: string, filters: any): Observable<IFeeStructures> {
    return this.httpClient.get<IFeeStructures>(url, {
      headers: { accept: '*/*' },
      params: filters,
    }) as Observable<IFeeStructures>;
  }

  getFeeSummary(url: string, filters: any): Observable<IFeeSummary> {
    return this.httpClient.get<IFeeSummary>(url, {
      headers: { accept: '*/*' },
      params: filters,
    }) as Observable<IFeeSummary>;
  }

  getPayments(url: string, filters: any): Observable<IPayments> {
    return this.httpClient.get<IPayments>(url, {
      headers: { accept: '*/*' },
      params: filters,
    }) as Observable<IPayments>;
  }

  getStudentFees(url: string, filters: any): Observable<IStudentFees> {
    return this.httpClient.get<IStudentFees>(url, {
      headers: { accept: '*/*' },
      params: filters,
    }) as Observable<IStudentFees>;
  }

  create(url: string, form: any): Observable<any> {
    return this.httpClient.post<any>(url, form, {
      headers: { accept: '*/*' },
    }) as Observable<any>;
  }

  edit(url: string, form: any): Observable<any> {
    return this.httpClient.patch<any>(url, form, {
      headers: { accept: '*/*' },
    }) as Observable<any>;
  }
}
